export const nav = {
  timezoneUTC: "Timezone: UTC{val}",
  copyrightYearVIATechnologiesInc: "Copyright © {year} VIA Technologies, Inc.",
  allRightsReserved: "All Rights Reserved.",
  logout: "Sign Out",
  logoutAndReturnToTheLoginPage: "Sign out and return to the sign in page?",
  billingAndPayment: "Billing and Payment",
  billingRecord: "@:payment.billingRecords",
  management: "Management",
  drivers: "Drivers",
  models: "Models",
  vehicles: "Vehicles",
  monitor: "Monitor",
  history: "History",
  inspectionReports: "Inspection Reports",
  liveTracking: "Live Tracking",
  uploadedVideos: "Uploaded Videos",
  settings: "Settings",
  system: "System Settings",
  geofence: "Geofence",
  inspection: "Inspection Template",
  users: "Users",
  accounts: "Accounts",
  roles: "Roles",
  dashboard: "Dashboard",
  updateAccountInformation: "Update Account Information",
  changePassword: "Change Password",
  VIAMobile360WorkXConnect: "VIA Mobile360 CWorkX Connect",
  workXConnect: "CWorkX Connect",
  support: "Support",
  maintenanceTemplate: "Maintenance Template",
  maintenanceRepair: "Operations",
  maintenance: "Maintenance",
  repair: "Repair",
  remind: "Reminder Settings",
  organization: "Organization",
  log: "Log",
  schedule: "Schedule",
  reportDownload: "Report Download",
  greetingSetting: "Greeting Words",
};
